<template>
    <div class="exhibition"> 
        <img :src="this.url" alt="">
        <router-link to="/home" tag="div"  class="exhibitionBut">点击进入报告</router-link>
    </div>
</template>
<script>
export default {
    data(){
     return{
         url:''
     }
    },
   created(){
        this.util.get(this.api.custom_cover, '', (success) => {
            this.url = success.cover
        })
   },
//    beforeCreate(){
//     if(window.location.origin === 'https://zydemo.genekang.com'){
//               this.util.get(this.api.childwes_zy_demo, '', (success) => {
//               for (let i in success.access_token) {
//                   this.util.setLS(this.api.access_token, success.access_token[i])
//               } 
//               this.util.setLS('access_token', success.access_token)
//               this.util.setLS(this.api.uid, success.uid)
//             })
//       }
//   },
}
</script>
<style  scoped>
    .exhibition{
        position: relative;
        width: 100%;
        height: 100%;
    }
   .exhibition img{
        width: 100%;
        height: 100%;
   }
   .exhibitionBut{
      background:  rgba(36, 90, 238, 0.4);
      width: 1.2rem;
      font-size: .14rem;
      color: #ffffff;
      position: absolute;
      text-align: center;
      top: calc(50% - .2rem);
      left: calc(50% - 0.5rem);
      height: .3rem;
      line-height: .3rem;
      border-radius: .06rem;
   }
</style>


// WEBPACK FOOTER //
// src/views/login/exhibition.vue